import { useCallback } from "react";
import type { ReactNode } from "react";
import {
  clearInfoModalContent,
  registerInfoModalContent
} from "../components/Shared/Modals/InfoModal/infoModalRegistry";
import type { InfoModalAction } from "../store/slices/modalSlice";
import { useAppDispatch } from "../store/hooks";
import { infoModalHidden, infoModalShown } from "../store/slices/modalSlice";

export type InfoModalOptions = {
  title: string;
  children: ReactNode;
  actions?: InfoModalAction[];
  onAction?: (actionName: string) => void;
};

export const useInfoModal = () => {
  const dispatch = useAppDispatch();

  const showInfoModal = useCallback(
    ({ title, children, actions, onAction }: InfoModalOptions) => {
      const id = registerInfoModalContent({ children, onAction });
      dispatch(infoModalShown({ id, title, actions }));
    },
    [dispatch]
  );
  const hideInfoModal = useCallback(() => {
    dispatch(infoModalHidden());
    clearInfoModalContent();
  }, [dispatch]);

  return { showInfoModal, hideInfoModal };
};
